export const TicketRejectUserAccess = [
  "receptionist",
  "manager",
  "cluster_manager",
  "admin",
];
